<template>
  <Layout>
    <b-row v-if="user && user.user_type !== 'customer'">
      <b-col v-for="(a, index) in topCardList" :key="a.name" xxl="3" sm="6">
        <b-card no-body class="card-animate">
          <b-card-body>
            <div class="d-flex justify-content-between"  style="height:110px">
              <div class="w-100">
                <p class="fw-medium text-muted mb-0">{{ a.name }}</p>
                <h2 class="mt-4 ff-secondary fw-semibold">
                  <count-to
                    :startVal="0"
                    :endVal="a.value"
                    :duration="5000"
                  ></count-to
                  >{{ index == 0 ? $t("overview_static.common['台']") : "" }}
                </h2>
                <div
                v-if="index == 0"
                  :style="{  width: '50%' }"
                  class="mb-0 text-muted d-flex justify-content-between"
                >
                  <div>
                    {{ $t("page.workOrderProcessing") }}: {{ a.value1
                    }}{{ index == 0 ? $t("overview_static.common['台']") : "" }}
                  </div>
                  <div>|</div>
                  <div>
                    {{ $t("报废") }}: {{ a.value2
                    }}{{ index == 0 ? $t("overview_static.common['台']") : "" }}
                  </div>
                </div>
                <div class="w-100 d-flex" v-if="index == 1">
                  <div class="d-flex text-muted">
                    <div>
                      {{ a.value1
                      }}{{ $t("overview_static.common['台']") }}
                    </div>
                    <div
                      class="ps-1 pe-1 ms-1"
                      style="
                        color: rgb(77, 207, 140);
                        background-color: rgba(77, 207, 140, 0.2);
                        border-radius: 4px;
                      "
                    >
                      {{ $t("overview_static.customer_page.online") }}
                    </div>
                    <div class="ms-2">
                      {{ a.value2
                      }}{{ $t("overview_static.common['台']") }}
                    </div>
                    <div
                      class="ps-1 pe-1 ms-1"
                      style="
                        background-color: rgba(244, 245, 245);
                        border-radius: 4px;
                      "
                    >
                      {{ $t("overview_static.customer_page.offline") }}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="avatar-sm flex-shrink-0">
                  <span
                    class="avatar-title bg-soft-info text-info rounded-circle fs-4"
                  >
                    <i class="ri-ticket-2-line"></i>
                  </span>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <!-- <div
        style="width: 300px; flex: none; margin-right: 1.5rem; max-height: 80vh;min-height:800px"
        class="card overflow-auto"
      >
        <equipSearchTree @treeChange="setEquipmentList"></equipSearchTree>
      </div> -->
      <div>
        <!-- <PageHeader :title="title" :items="items" /> -->
        <div class="card">
          <b-card-header class="border-0">
            <div class="d-flex align-items-center">
              <h5 class="card-title mb-0 flex-grow-1">
                {{ this.$t("menu.equipment-management.text") }}
              </h5>
              <div class="flex-shrink-0">
                <div class="d-flex flex-wrap">
                  <router-link
                    :to="{
                      path: '/asset/form',
                      query: {
                        type: 'create',
                        title: this.$t('page.work-order.device.create'),
                      },
                    }"
                    class="btn btn-primary text-light me-2"
                    v-perm="'device.post'"
                    ><i class="ri-add-line align-bottom me-1"></i
                    >{{
                      this.$t("menu.equipment-management.AddEquipment")
                    }}</router-link
                  >
                  <button
                    v-if="user && user.user_type !== 'customer'"
                    class="btn btn-primary me-2"
                    @click="exportDevice"
                  >
                    <i class="ri-download-2-line align-bottom me-1"></i
                    >{{ this.$t("menu.equipment-management.export") }}
                  </button>
                  <button
                    v-if="user && user.user_type !== 'customer'"
                    class="btn btn-primary"
                    @click="showImportDevice"
                    v-perm="'device.post'"
                  >
                    <i class="ri-upload-2-line align-bottom me-1"></i
                    >{{ this.$t("menu.equipment-management.import") }}
                  </button>
                </div>
              </div>
            </div>
          </b-card-header>
          <div
            class="card-body border border-dashed border-end-0 border-start-0"
          >
            <!-- search-part -->
            <b-row class="g-3">
              <Search
                v-model:tableData="tableData"
                :search-default="searchVal"
                :qrcodeOptions="qrcodeOptions"
                @initData="initData"
              ></Search>
              <b-col
                xxl="2"
                class="d-flex justify-content-end align-items-end align-self-center"
              >
                <button
                  v-if="user && user.user_type !== 'customer'"
                  class="btn btn-primary ps-1 pe-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i class="ri-filter-2-line align-bottom me-1"></i
                  >{{ selectedTheadNum
                  }}{{ this.$t("menu.equipment-management.ColumnSelected") }}
                </button>
                <div class="dropdown-menu dropdownmenu-info">
                  <template v-for="(th, i) in column" :key="i">
                    <div class="form-check mb-2 ms-2" v-perm="th.permCode">
                      <input
                        class="form-check-input me-1"
                        type="checkbox"
                        v-model="th.isShow"
                        @change="tHeadChange($event, i)"
                      />
                      <label class="form-check-label">{{ th.title }}</label>
                    </div>
                  </template>
                </div>
                <button
                  v-if="user && user.user_type !== 'customer'"
                  class="btn btn-primary ms-2 ps-1 pe-1"
                  @click="exportDeviceQRCode"
                >
                  <i class="ri-download-2-line align-bottom me-1"></i
                  >{{ this.$t("menu.equipment-management.QrcodeExport") }}
                </button>
              </b-col>
            </b-row>
          </div>
          <div class="card">
            <div class="card-header me-2 ms-2">
              <ul
                class="nav nav-tabs-custom rounded card-header-tabs nav-justified border-bottom-0 mx-n3"
                role="tablist"
              >
                <template v-for="(tab, i) in tabsList" :key="i">
                  <li class="nav-item">
                    <a
                      class="d-flex align-items-center"
                      :class="[
                        'nav-link',
                        tabActive == tab.href && 'active',
                        i > 1 && 'disabled',
                        'fs-16',
                      ]"
                      :style="{
                        cursor: 'pointer',
                        color:
                          tabActive == tab.href
                            ? '#6691E7'
                            : i > 1
                            ? ''
                            : '#495057',
                      }"
                      data-bs-toggle="tab"
                      @click.prevent="switchTab(tab.href)"
                      role="tab"
                    >
                      <img
                        style="width: 1rem; margin-right: 5px"
                        :src="
                          tabActive == tab.href ? tab.icon : tab.icon_inactive
                        "
                      />
                      <span>
                        {{ tab.title }}
                      </span>
                    </a>
                  </li>
                </template>
              </ul>
            </div>
          </div>
          <div class="card-body">
            <!-- table-part -->
            <div class="position-relative">
              <div
                :class="[
                  'table-responsive',
                  'table-card',
                  'mb-1',
                  'table-page-responsive',
                  'table-ellipsis',
                ]"
                style="min-height: 500px"
              >
                <Table
                  :column="column"
                  :tableData="tableData"
                  :actionIcon="actionIcon"
                  :refreshData="initData"
                  :show-checkbox="true"
                  :product-type="productType"
                  source="equipment-management"
                  v-model:singleData="singleData"
                  @checkAllChanged="checkAllChanged"
                  @singleChecked="singleChecked"
                  @changeMoreStatus="changeMoreStatus"
                  @changeSort="changeSort"
                  :default-sort="sort"
                  ref="equipmentTable"
                  :qrcodeOptions="qrcodeOptions"
                ></Table>
                <table-loading
                  :count="data_length"
                  :table-loading="isLoading"
                  :table-loaded="!isLoading"
                  :show-no-result-tip="false"
                ></table-loading>
              </div>
              <div :class="[isLoading && 'visually-hidden']">
                <!-- paginate-part-->
                <Pagination
                  v-if="tableData.length"
                  class="me-3"
                  v-model:page="page"
                  v-model:perPage="perPage"
                  :pages="pages"
                  :prePageOption="prePageOption"
                  :tab_info_length="data_length"
                ></Pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="modalProgressRef"
      v-model="modalProgress"
      class="v-modal-custom"
      @hide="handleModalProgressHide"
      @hidden="handleModalProgressHidden"
      :hide-header-close="isImported && isImportProgressing"
      :no-close-on-backdrop="isImported && isImportProgressing"
      :no-close-on-esc="isImported && isImportProgressing"
      :title="this.$t('menu.equipment-management.ImportDevice')"
      header-class="border-bottom pb-3"
      size="lg"
      centered
    >
      <DropZone
        accept=".xlsx, .xls"
        :fileInfo="fileInfo"
        ID="uploadImportDevice"
        @drop.prevent="drop"
        @change="selectedFile"
      />
      <div class="text-muted mt-2 fs-5">
        <i class="ri-information-line"></i>
        <label class="align-top"
          >{{ this.$t("menu.equipment-management.EnterDeviceInformationClick")
          }}<a :href="templateUrl" target="_blank">{{
            $t("menu.equipment-management.download")
          }}</a
          >{{ $t("menu.equipment-management.ObtainTheDeviceTemplate") }}</label
        >
      </div>
      <ul class="list-unstyled mb-0" v-show="importFile">
        <li class="mt-2 dz-processing dz-success dz-complete" id="">
          <div class="border rounded bg-light">
            <div class="d-flex px-2 pt-2">
              <div class="flex-shrink-0 me-3">
                <div class="avatar-sm">
                  <div
                    class="avatar-title bg-light text-success rounded"
                    style="font-size: 2.5rem !important"
                  >
                    <i class="ri-file-excel-2-fill"></i>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1">
                <div class="pt-1">
                  <h5 class="fs-5 mb-1">{{ importFile && importFile.name }}</h5>
                  <p class="fs-6 text-muted mb-0">{{ progressValue }}%</p>
                  <strong class="error text-danger"></strong>
                </div>
              </div>
              <div class="flex-shrink-0 ms-3">
                <button
                  type="button"
                  class="btn-close"
                  @click="deleteRecord"
                  v-show="!isImported"
                ></button>
              </div>
            </div>
            <div class="d-flex pt-0 pb-3 px-3" v-show="isImported">
              <div class="flex-grow-1">
                <b-progress class="animated-progress">
                  <b-progress-bar :value="progressValue"> </b-progress-bar>
                </b-progress>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <template v-slot:footer>
        <button
          class="btn btn-outline-primary btn-md btn w-sm"
          type="button"
          data-bs-dismiss="modal"
          v-show="!isImported"
        >
          {{ this.$t("base.cancel") }}
        </button>
        <button
          class="btn btn-primary btn-md btn w-sm"
          type="button"
          @click="handleImport"
          :disabled="isImported || !this.importFile"
          v-show="!isImported || isImportProgressing"
        >
          {{ this.$t("menu.equipment-management.ToChannel") }}
        </button>
        <button
          class="btn btn-primary btn-md btn w-sm"
          type="button"
          data-bs-dismiss="modal"
          v-show="isImported && !isImportProgressing"
        >
          {{ this.$t("menu.equipment-management.accomplish") }}
        </button>
      </template>
    </b-modal>
    <MessageAlert
      :alertInfo="alertInfo"
      v-if="formValidataAlert"
    ></MessageAlert>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
// import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
// import equipSearchTree from "../../components/equipSearchTree.vue";
import Search from "./search";
import Table from "./table";
// import Empty from "@/components/common/Empty";
import Pagination from "@/components/common/Pagination.vue";
import _ from "loadsh";
import MessageAlert from "@/components/common/MessageAlert";
import Swal from "sweetalert2";
import {
  getInstancesList,
  postBindQRCode,
  instancesStatistics,
  getDeviceImportTemplateUrl,
} from "@/service/index";
// import moment from "moment";
import { API_SVC_HOST, SF_API_PREFIX } from "@/config/common";
import { getTimezone, urlFormat } from "@/helpers/common";
import { successMsg } from "@/helpers/swal";
import axios from "axios";
import TableLoading from "@/views/widgets/table-loading";
import DropZone from "@/components/widgets/dropZone";
import i18n from "@/i18n";
import {
  APP_INDUSTRY_LIST,
  CUSTOME_ATTR_LIST,
  CUSTOMER_INDUSTRY_LIST,
} from "@/config/common";
import { CountTo } from "vue3-count-to";
let routeFrom = null;
export default {
  name: "equipment-management",
  page: {
    title: i18n.global.t("menu.equipment-management.text"),
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    // PageHeader,
    // equipSearchTree,
    Search,
    Table,
    // Empty,
    Pagination,
    MessageAlert,
    TableLoading,
    DropZone,
    CountTo,
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    instanceExportUrl() {
      return urlFormat(
        API_SVC_HOST,
        SF_API_PREFIX,
        "/api/instances/exportexcelvideo"
      );
    },
    qrcodeExportUrl() {
      return urlFormat(
        API_SVC_HOST,
        SF_API_PREFIX,
        "/api/instances/export-qrcode"
      );
    },
    deviceImportUrl() {
      return urlFormat(API_SVC_HOST, SF_API_PREFIX, "/api/import/device");
    },
    productType() {
      if (this.tabActive === "pump") {
        return 1;
      }
      return 2;
    },
  },
  data() {
    return {
      title: this.$t("menu.equipment-management.text"),
      items: [
        {
          text: this.$t("menu.equipment-management.text"),
          href: "/equipment-management",
        },
        {
          text: this.$t("menu.equipment-management.DeviceList"),
          active: true,
        },
      ],
      qrcodeOptions: [
        { value: 0, label: this.$t("menu.equipment-management.NotBound") }, //未绑定
        { value: 1, label: this.$t("menu.equipment-management.Bound") }, //已绑定
        { value: 2, label: this.$t("menu.equipment-management.UnabletoBound") }, //无法绑定
      ],
      column: [
        {
          dataIndex: "name",
          title: this.$t("page.device_name"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "设备厂商",
          title: this.$t("page.EquipmentManufacturer"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "root_sn",
          title: this.$t("page.pump_head_serial_number"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "group_sn",
          title: this.$t("page.unit_serial_number"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "所在位置",
          title: this.$t("page.locationOn"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "发货时间",
          title: this.$t("page.device-attr.delivery_time"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "customer_txt",
          title: this.$t("page.customer_name"),
          isShow:
            JSON.parse(localStorage.getItem("user")) &&
            JSON.parse(localStorage.getItem("user")).user_type !== "customer",
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "应用行业",
          title: this.$t("page.applicationIndustry"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "维保服务商",
          title: this.$t("page.tending.service_provider"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "设备状态",
          title: this.$t("page.deviceStatus"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "is_qrcode_bind",
          title: this.$t("menu.equipment-management.QrcodeBinding"),
          isShow:
            JSON.parse(localStorage.getItem("user")) &&
            JSON.parse(localStorage.getItem("user")).user_type !== "customer",
          canView: false,
          permCode: "device.get",
        },
        {
          dataIndex: "created_time",
          title: this.$t("page.create-time"),
          isShow: true,
          canView: false,
          permCode: "device.get",
        },
      ],
      tabsList: [
        {
          title: this.$t("page.work-order.device.single"),
          href: "pump",
          icon: require("@/assets/images/devices/dev-1.png"),
          icon_inactive: require("@/assets/images/devices/dev-2.png"),
        },
        {
          title: this.$t("page.work-order.device.unit_type"),
          href: "unit",
          icon: require("@/assets/images/devices/dev-3.png"),
          icon_inactive: require("@/assets/images/devices/dev-4.png"),
        },
      ],
      tabActive: "pump",
      actionIcon: [
        {
          textType: "primary",
          iconClass: "ri-pencil-fill",
          type: "edit",
          permCode: "device.put",
        },
        {
          textType: "primary",
          iconClass: "ri-eye-fill",
          type: "view",
          permCode: "device.get",
        },
        {
          textType: "danger",
          iconClass: "ri-delete-bin-5-fill",
          type: "delete",
          permCode: "device.delete",
        },
      ],
      isLoading: false,
      tableData: [],
      // originData: [],
      singleData: {},
      isShowForm: false,
      /* 分页 */
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      data_length: 0,
      selectedTheadNum: 0,
      dataList: [],
      equipmentList: [],
      alertInfo: {
        content: "",
        variant: "danger",
        icon: "ri-error-warning-line",
      },
      formValidataAlert: false,
      searchVal: {
        keyword: "",
        service_company: "",
        customer: "",
        created_time: "",
        is_qrcode_bind: undefined,
      },
      modalProgress: false,
      progressValue: 0,
      importFile: null,
      isImported: false,
      isImportProgressing: false,
      fileInfo: {
        title: this.$t("page.DragDropFilesSelectFileUpload"),
        accept: "EXCEL",
        limit: "50M",
      },
      sort: null,
      topCardList: [
        {
          name: this.$t("menu.equipment-management.total_equipment"),
          value: 0,
          value1: 0,
          value2: 0,
        },
        { name: "IoT Activated", value: 0,value1: 0,
          value2: 0, },
        { name: "IoT Ready", value: 0 },
        {
          name: this.$t(
            "menu.equipment-management.annual_equipment_installed_capacity"
          ),
          value: 0,
        },
      ],
      templateUrl: "https://fs.iiot-prd.gdnash.com.cn/oodt/template_v1.xlsx",
    };
  },
  watch: {
    $route: {
      handler() {
        this.initData();
      },
      // 深度观察监听
      deep: true,
    },
    tableData: {
      handler(newVal) {
        this.$store.commit(
          "equipManagement/set_old_tabledata",
          JSON.stringify(newVal)
        );
        // const totalPage = Math.ceil(newVal.length / this.perPage); // 总页数
        // this.page = this.page > totalPage ? totalPage : this.page;
        // this.page = this.page < 1 ? 1 : this.page;
        this.setPages();
      },
      deep: true,
      immediate: true,
    },
    column: {
      handler(newVal) {
        let list = newVal.filter((item) => {
          return item.isShow;
        });
        this.selectedTheadNum = list.length;
      },
      deep: true,
      immediate: true,
    },
    perPage(val) {
      if (val) {
        this.page = 1;
        this.initData();
        // this.paginate(this.tableData);
      }
    },
    page() {
      if (this.page > 0) {
        this.$refs.equipmentTable.closeAll();
        this.initData();
      } else {
        this.page = 1;
      }
    },
  },
  methods: {
    getInstancesStatistics() {
      instancesStatistics().then((res) => {
        if (res && res.payload) {
          this.topCardList.map((item) => {
            if (
              item.name == this.$t("menu.equipment-management.total_equipment")
            ) {
              //设备总量
              item.value = res.payload["total"] || 0;
              item.value1 = res.payload["running"] || 0;
              item.value2 = res.payload["scrapped"] || 0;
            }
            if (item.name == "IoT Activated") {
              item.value = res.payload["iot_activated"] || 0;
              item.value1 = res.payload["iot_online"] || 0;
              item.value2 = res.payload["iot_offline"] || 0;
            }
            if (item.name == "IoT Ready") {
              item.value = res.payload["iot_ready"] || 0;
            }
            if (
              item.name ==
              this.$t(
                "menu.equipment-management.annual_equipment_installed_capacity"
              )
            ) {
              //"年度设备装机量"
              item.value = res.payload["annual_installed"] || 0;
            }
          });
        }
      });
    },
    initData(val) {
      if (val) {
        this.searchVal = val;
        this.page = 1;
      }
      var list = [];
      this.tableData = [];
      let params = {
        page: val ? 1 : this.page,
        page_size: this.perPage,
        keyword: this.searchVal.keyword || "",
        service_company: this.searchVal.service_company || "",
        customer: this.searchVal.customer || "",
        product_type: this.productType,
        is_qrcode_bind: this.searchVal.is_qrcode_bind,
        sort: this.sort,
      };

      if (
        this.searchVal.created_time instanceof Array &&
        this.searchVal.created_time.length == 2
      ) {
        let _time = _.cloneDeep(this.searchVal.created_time[1]);
        _time.setHours(23, 59, 59, 999);
        params.created_time_after = this.searchVal.created_time[0].getTime();
        params.created_time_before = _time.getTime();
      }

      this.isLoading = true;
      getInstancesList(params)
        .then((res) => {
          if (res.payload.data) {
            this.data_length = _.get(res, ["payload", "count"]);
            this.getEquipmentArr(res.payload.data).map((item) => {
              //   if (
              //     JSON.parse(localStorage.getItem("equipmentData")).id ==
              //       item.id &&
              //     JSON.parse(localStorage.getItem("equipmentData")).name ==
              //       item.name
              //   ) {
              //       }
              //     localStorage.setItem("equipmentData", JSON.stringify(item));
              list.push(item);
              this.setEquipmentList({ list });
            });
            this.getInstancesStatistics();
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeSort(val) {
      this.sort = val;
      this.initData();
    },
    switchTab(tab) {
      this.tabActive = tab;
      this.initData({ ...this.searchVal });
    },
    setEquipmentList({ list }) {
      this.isLoading = true;
      let infoList = [];
      list.forEach((item) => {
        let info = {
          id: item.id,
          name: item.name,
          root_sn: item.root_sn,
          group_sn: item.group_sn,
          has_parent: item.has_parent,
          has_children: item.has_children,
          parent_id: item.parent_id,
          is_qrcode_bind: item.is_qrcode_bind,
          root_sn_list: item.root_sn_list,
          created_time: item.created_time,
          service_company_id: item.service_company_id,
          service_company_txt: item.service_company_txt,
          customer_txt: item.customer_txt,
        };
        if (item.attributes.attributes) {
          item.attributes.attributes.forEach((attr) => {
            // if (attr.group == "设备出厂信息" || attr.group == "设备管理信息")
            info[attr.name] = attr.value;
          });
        }
        infoList.push(info);
      });
      this.tableData = infoList;
      this.setPages();
      this.isLoading = false;
      // setTimeout(() => {
      //   this.tableData = infoList;
      //   this.setPages();
      //   this.isLoading = false;
      // }, 500);
    },
    /* 筛选分页数据 */
    paginate(data) {
      let page = this.page;
      let perPage = this.perPage;
      let from = page * perPage - perPage;
      let to = page * perPage;
      return data.slice(from, to);
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      let numberOfPages = Math.ceil(this.data_length / this.perPage);

      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    tHeadChange(ev, i) {
      this.column[i].isShow = ev.target.checked;
    },
    getifHoliday(url) {
      return new Promise((resolve) => {
        //此接口为循环调用的接口，按照自己的需要进行修改
        axios
          .get(url, {
            // responseType: "blob",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          })
          .then((res) => {
            resolve(res);
          });
      });
    },
    async ifHolidayfun(url, handle) {
      let timer = null;
      timer = setInterval(async () => {
        let ifHoliday = await this.getifHoliday(url);
        handle(timer, ifHoliday.data);
      }, 1000);
    },
    exportDeviceQRCode() {
      if (!this.tableData.length) return;
      Swal.fire({ title: this.$t("base.exporting"), showConfirmButton: false });
      Swal.showLoading();
      let params = {
        keyword: this.searchVal.keyword || "",
        service_company: this.searchVal.service_company || "",
        customer: this.searchVal.customer || "",
        sort: this.sort,
        is_qrcode_bind: this.searchVal.is_qrcode_bind,
        product_type: this.productType, //识别二维码，区分单体，机组
      };

      if (
        this.searchVal.created_time instanceof Array &&
        this.searchVal.created_time.length == 2
      ) {
        let _time = _.cloneDeep(this.searchVal.created_time[1]);
        _time.setHours(23, 59, 59, 999);
        params.created_time_after = this.searchVal.created_time[0].getTime();
        params.created_time_before = _time.getTime();
      }

      axios
        .post(this.qrcodeExportUrl, params, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        })
        .then((res) => {
          if (!res.data.payload.request_id) return;
          this.ifHolidayfun(
            this.qrcodeExportUrl + "?request_id=" + res.data.payload.request_id,
            (timer, data) => {
              if (data.payload.status == "ok") {
                let link = document.createElement("a");
                link.href = data.payload.url;
                link.download =
                  data.payload.file_name ||
                  this.$t("menu.equipment-management.DeviceListExportZip");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); //下载完成移除元素
                Swal.close();
                clearInterval(timer);
              }
            }
          );
        })
        .catch((err) => {
          Swal.close();
          this.handleAlert("danger", err || this.$t("base.file_export_failed"));
        });
    },
    exportDevice() {
      if (!this.tableData.length) return;
      Swal.fire({ title: this.$t("base.exporting"), showConfirmButton: false });
      Swal.showLoading();
      let columns = {
        产品类型: this.$t("page.product-info.type"),
        二维码绑定: this.$t("menu.equipment-management.QrcodeBinding"),
        设备型号: this.$t("设备型号"),
        产品: this.$t("page.products"),
        设备名称: this.$t("设备名称"),
        序列号: this.$t("序列号"),
        所属机组序列号: this.$t("所属机组序列号"),
        维保服务商: this.$t("维保服务商"),
        客户名称: this.$t("客户名称"),
        GDNC订单号: this.$t("GDNC订单号"),
        发货时间: this.$t("发货时间"),
        设备状态: this.$t("设备状态"),
        设备厂商: this.$t("设备厂商"),
        设备品牌: this.$t("设备品牌"),
        设备创建时间: this.$t("设备创建时间"),
        设备资产编码: this.$t("设备资产编码"),
        应用行业: this.$t("应用行业"),
        所在位置: this.$t("所在位置"),
        详细地址: this.$t("详细地址"),
        应用车间: this.$t("应用车间"),
        应用工艺: this.$t("应用工艺"),
        设备联系人: this.$t("设备联系人"),
        设备联系电话: this.$t("设备联系电话"),
        销售渠道: this.$t("销售渠道"),
        销售: this.$t("销售"),
        客户编码: this.$t("客户编码"),
        客户属性: this.$t("客户属性"),
        客户行业: this.$t("客户行业"),
        客户地址: this.$t("客户地址"),
        客户电话: this.$t("客户电话"),
        客户邮箱: this.$t("客户邮箱"),
        客户官网: this.$t("客户官网"),
        客户采购联系人: this.$t("客户采购联系人"),
        客户采购联系人电话: this.$t("客户采购联系人电话"),
        质保到期时间: this.$t("质保到期时间"),
      };
      let langs = {
        产品类型: {
          1: this.$t("page.work-order.device.single"),
          2: this.$t("page.work-order.device.unit_type"),
        },
        二维码绑定: {
          0: this.$t("menu.equipment-management.NotBound"), //未绑定
          1: this.$t("menu.equipment-management.Bound"), //已绑定
          2: this.$t("menu.equipment-management.UnabletoBound"), //无法绑定
        },
        设备状态: {
          在用: this.$t("在用"),
          报废: this.$t("报废"),
        },
        应用行业: APP_INDUSTRY_LIST.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
        客户属性: CUSTOME_ATTR_LIST.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
        客户行业: CUSTOMER_INDUSTRY_LIST.reduce((obj, item) => {
          obj[item.value] = item.label;
          return obj;
        }, {}),
      };

      let params = {
        keyword: this.searchVal.keyword || "",
        service_company: this.searchVal.service_company || "",
        customer: this.searchVal.customer || "",
        sort: this.sort,
        is_qrcode_bind: this.searchVal.is_qrcode_bind,
        tz: getTimezone(),
        langs,
        columns,
        file_name: this.$t("menu.equipment-management.DeviceList"),
      };

      if (
        this.searchVal.created_time instanceof Array &&
        this.searchVal.created_time.length == 2
      ) {
        let _time = _.cloneDeep(this.searchVal.created_time[1]);
        _time.setHours(23, 59, 59, 999);
        params.created_time_after = this.searchVal.created_time[0].getTime();
        params.created_time_before = _time.getTime();
      }
      axios
        .post(this.instanceExportUrl, params, {
          // responseType: "blob",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        })
        .then((res) => {
          if (!res.data.payload.request_id) return;
          this.ifHolidayfun(
            this.instanceExportUrl +
              "?request_id=" +
              res.data.payload.request_id,
            (timer, data) => {
              if (data.payload.status == "ok") {
                let link = document.createElement("a");
                link.href = data.payload.url;
                link.download = data.payload.file_name || "设备列表导出.zip";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); //下载完成移除元素
                Swal.close();
                clearInterval(timer);
              }
            }
          );
        })
        .catch((err) => {
          Swal.close();
          this.handleAlert("danger", err || this.$t("base.file_export_failed"));
        });
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.formValidataAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.formValidataAlert = false;
      }, duration);
    },
    getEquipmentArr(data) {
      let result = [];
      let queue = data;
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          result.push(child);
          child.children && queue.push(...child.children);
        });
      }
      return result;
    },
    handleModalProgressHidden() {
      this.progressValue = 0;
      document.getElementById("uploadImportDevice").value = "";
      this.importFile = null;
      this.isImported = false;
      this.isImportProgressing = false;
    },
    handleModalProgressHide(e) {
      const CLASS_NAME_STATIC = "modal-static";
      if (this.isImported && this.isImportProgressing) {
        e.preventDefault();
        let element = document.getElementsByClassName("v-modal-custom")[0];
        const initialOverflowY = element.style.overflowY;
        if (
          initialOverflowY === "hidden" ||
          element.classList.contains(CLASS_NAME_STATIC)
        ) {
          return;
        }
        element.classList.add(CLASS_NAME_STATIC);
        element.style.overflowY = "hidden";

        let { transitionDuration, transitionDelay } =
          window.getComputedStyle(element);

        const floatTransitionDuration = Number.parseFloat(transitionDuration);
        const floatTransitionDelay = Number.parseFloat(transitionDelay);

        let ms = 300;
        if (floatTransitionDuration || floatTransitionDelay) {
          transitionDuration = transitionDuration.split(",")[0];
          transitionDelay = transitionDelay.split(",")[0];

          ms =
            (Number.parseFloat(transitionDuration) +
              Number.parseFloat(transitionDelay)) *
              1000 +
            5;
        }

        setTimeout(function () {
          element.classList.remove(CLASS_NAME_STATIC);
          element.style.overflowY = initialOverflowY;
        }, ms);
        return;
      }
    },
    showImportDevice() {
      this.modalProgress = true;
      getDeviceImportTemplateUrl().then((res) => {
        if (res && res.payload && res.payload.url) {
          this.templateUrl = res.payload.url;
        }
      });
    },
    hideImportDevice() {
      this.modalProgress = false;
    },
    handleImport() {
      if (!this.importFile) return;

      this.isImported = true;
      this.isImportProgressing = true;

      var form = new FormData();
      form.append("file", this.importFile);

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      };
      axios
        .post(this.deviceImportUrl, form, config)
        .then((res) => {
          if (!res.data.payload.request_id) return;
          this.ifHolidayfun(
            this.deviceImportUrl + "?request_id=" + res.data.payload.request_id,
            (timer, data) => {
              if (data.payload.status == "completed") {
                this.progressValue = parseInt(data.payload.progress);
                this.isImportProgressing = false;
                this.initData();
                clearInterval(timer);
              } else if (data.payload.status == "processing") {
                this.progressValue = parseFloat(data.payload.progress);
              } else {
                this.isImportProgressing = false;
                clearInterval(timer);
              }
            }
          );
        })
        .catch((err) => {
          Swal.close();
          this.handleAlert("danger", err || this.$t("base.file_export_failed"));
        });
    },
    drop(e) {
      this.importFile = e.dataTransfer.files[0];
    },
    selectedFile() {
      this.importFile = document.querySelector(".dropzoneFile").files[0];
    },
    deleteRecord() {
      this.importFile = null;
      document.getElementById("uploadImportDevice").value = "";
    },
    /* 表格全选 */
    checkAllChanged(allChecked) {
      this.allChecked = allChecked;
      this.tableData.forEach((item) => {
        item.checked = allChecked;
      });
    },
    /* 表格项单选 */
    singleChecked(id, checked) {
      let i = this.tableData.findIndex((item) => {
        return item.id == id;
      });
      if (i != -1) {
        this.tableData[i].checked = checked;
      }
      this.allChecked = this.tableData.every((item) => {
        return item.checked;
      });
    },

    //批量更改二维码绑定状态
    changeMoreStatus(op) {
      Swal.fire({
        title: this.$t("page.event-management.BatchModification"),
        showConfirmButton: false,
      });
      Swal.showLoading();
      let checkedItems = this.tableData.filter((item) => {
        return item.checked;
      });
      let checkedIds = [];
      checkedItems.forEach((eve) => {
        checkedIds.push(eve.id);
      });

      let params = {
        batch: true,
        op: op,
        ids: checkedIds,
      };
      postBindQRCode(params)
        .then((res) => {
          Swal.close();
          if (res && res.meta && res.meta.code == 200) {
            // this.tableData.map((item)=>{
            //   item.is_qrcode_bind = op
            //   item.checked = false
            // })
            checkedItems.map((item) => {
              item.checked = false;
              item.is_qrcode_bind = op;
            });
            successMsg(this.$t("base.operate_success"));
          }
        })
        .catch((e) => {
          Swal.close();
          console.log(e);
        });
    },
  },
  mounted() {
    // this.initData();
    this.getInstancesStatistics();
  },
  beforeRouteEnter(to, from, next) {
    routeFrom = from.name;
    next();
  },
  activated() {
    if (!["equipment-detail", "asset-form"].includes(routeFrom)) {
      this.page = 1;
      this.searchVal = {
        keyword: "",
        service_company: "",
        customer: "",
        created_time: "",
      };
      this.sort = null;
    }
    // 清理详情页的tab缓存历史
    localStorage.removeItem("instanceDetailTabHistory");
    localStorage.removeItem("instanceDetailCurrentTab");
    this.initData();
  },
};
</script>
<style lang="scss" scoped>
.nav-tabs-custom .nav-item {
  flex-basis: initial !important;
  flex-grow: initial !important;
}
</style>
